<template>
  <mdb-navbar-nav >
    <mdb-nav-item href="/" active icon="home">Home</mdb-nav-item>
    <mdb-dropdown tag="li" class="nav-item">
      <mdb-dropdown-toggle tag="a" navLink color="indigo" slot="toggle" waves-fixed>Dropdown</mdb-dropdown-toggle>
      <mdb-dropdown-menu>
        <mdb-dropdown-item>Action</mdb-dropdown-item>
        <mdb-dropdown-item>Another action</mdb-dropdown-item>
        <mdb-dropdown-item>Something else here</mdb-dropdown-item>
      </mdb-dropdown-menu>
    </mdb-dropdown>
  </mdb-navbar-nav>
</template>
<script>
import { mdbNavbarNav, mdbNavItem, mdbDropdown, mdbDropdownMenu, mdbDropdownToggle, mdbInput, mdbDropdownItem } from 'mdbvue';
import { mapState, mapMutations, mapActions } from 'vuex';
import { LOGOUT } from '@/store/modules/auth/AuthType'
export default {
  name: 'LoginMenu',
  components: {
    mdbNavbarNav,
    mdbNavItem,
    mdbDropdown,
    mdbDropdownMenu,
    mdbDropdownToggle,
    mdbDropdownItem
  }
}
</script>
